<ng-container *ngIf="multi; else single">
  <div [formGroup]="formGroup">
    <p-multiSelect
      *ngIf="taskCategory$ | async as tc"
      [options]="tc"
      optionLabel="name_primary_language"
      placeholder="{{ placeHolder }}"
      styleClass="{{ styleClass }}"
      [formControl]="controlName"
      aria-label="task-category-multi-select"
    >
    </p-multiSelect>
  </div>
</ng-container>

<ng-template #single>
  <div [formGroup]="formGroup">
    <p-select
      *ngIf="taskCategory$ | async as tc"
      [options]="tc"
      optionLabel="name_primary_language"
      placeholder="{{ placeHolder }}"
      styleClass="{{ styleClass }}"
      [formControl]="controlName"
      aria-label="task-category-dropdown"
    >
      <ng-template pTemplate="TaskCategory">
        <div class="text-sm" *ngIf="TaskCategory">
          {{ TaskCategory.name_primary_language }}
        </div>
      </ng-template>

      <ng-template let-taskCategory pTemplate="item">
        <div class="text-sm">{{ taskCategory.name_primary_language }}</div>
      </ng-template>
    </p-select>
  </div>
</ng-template>
